export { CMS_LOCALES } from '../../../../../../api/src/_core/craft-cms/carft-cms.model';
import { Country } from '../../../../../../api/src/_core/utils/utils.data';

export const COUNTRY_OPTIONS = [
	{ value: Country.US, text: 'United States' },
	{ value: Country.CA, text: 'Canada' },
	{ value: Country.CN, text: 'China' }
];
